import { render } from "./ViewAllReports.vue?vue&type=template&id=522863be"
import script from "./ViewAllReports.vue?vue&type=script&lang=js"
export * from "./ViewAllReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__